module.exports = __webpack_public_path__ + "static/media/t-shirt_480.fa5e7bb2.jpg";